import React, { Component } from 'react'
import { Link } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'
import { LIVE_MANAGE_PATH } from '@constant'

export default class extends Component {
  render() {
    const header = [<Link to={LIVE_MANAGE_PATH}>视频直播</Link>, '查看优秀案例']

    return (
      <HeaderView header={header} title="查看优秀案例">
        查看优秀案例
      </HeaderView>
    )
  }
}
